export default {
  acomodacao: null,
  descrProcedimento: null,
  quantidade: null,
  grau: null,
  valorTotal: 0.00,
  codigoUnico: null,
  sequencial: 1,
  valorUnitario: 0.00,
  urgente: null,
  viaAcesso: 1,

  isNew: true,
  isValid: false,
  showErrors: false,
}
